import React from 'react';
import { Link } from 'react-router-dom';
import V2SEO from '../components/V2SEO';
import { services } from '../data/realContent';

const Services = () => (
  <>
    <V2SEO
      title="Drone Services in Lehigh Valley & Pennsylvania — Commercial, Event, FPV, Real Estate"
      description="FAA-certified drone services in Pennsylvania: commercial drone production, event coverage, FPV interiors, real estate aerial photography, and construction documentation. Based in the Lehigh Valley, serving the East Coast."
      path="/services"
      keywords="drone services Pennsylvania, drone services Lehigh Valley, commercial drone, event drone, FPV drone, real estate drone, aerial photography Allentown Bethlehem Easton"
    />

    <section className="v2-svc-hero">
      <div className="v2-container">
        <span className="v2-eyebrow">Services</span>
        <h1>
          Professional Drone Services in the Lehigh Valley
        </h1>
        <p className="v2-prose" style={{ marginTop: '1.2rem' }}>
          Cosmik Drones provides FAA-certified aerial cinematography and photography for
          businesses, production companies, and property professionals throughout Pennsylvania
          and the East Coast. Every service below is backed by real client work.
        </p>
      </div>
    </section>

    <section className="v2-section v2-section--tight">
      <div className="v2-container">
        <div className="v2-services">
          {services.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="v2-service v2-service--media" style={{ minHeight: 300 }}>
              {s.cardImage && <img src={s.cardImage} alt="" loading="lazy" aria-hidden="true" />}
              <h3>{s.name}</h3>
              <p>{s.blurb}</p>
              <span className="v2-service__cta">Learn More</span>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <section className="v2-section">
      <div className="v2-container">
        <div className="v2-cta">
          <span className="v2-eyebrow">Not sure which service fits?</span>
          <h2>Tell us about your project.</h2>
          <p>Describe what you need and we'll recommend the right approach, with a clear quote and timeline.</p>
          <Link to="/contact" className="v2-btn v2-btn--primary">Request a Quote</Link>
        </div>
      </div>
    </section>
  </>
);

export default Services;
